import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useEditAIPromptMutation } from "@/redux/services/aiPromptsApi"
import { setToast } from "@/redux/toastSlice"
import type { AiPromptPayload } from "@/types/entities/ai-prompt"

export const useEditAiPrompt = () => {
  const dispatch = useAppDispatch()
  const [editAiPrompt, response] = useEditAIPromptMutation()

  const handleEditAiPrompt = async ({
    body,
    id,
  }: {
    body: AiPromptPayload
    id: string
  }) => {
    try {
      const response = await editAiPrompt({ body, id }).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success edit prompt",
          }),
        )
      }
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { editAIPrompt: handleEditAiPrompt, response }
}
